import { useCallback } from 'react';

import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';

import { IRestaurant } from '@rbi-ctg/store';

import { IStoreDiagnostics } from '../types';
import { getAvailableDayParts } from '../utils';

export const useStoreDiagnostics = () => {
  const {
    isStoreAvailableForPickup,
    isStoreAvailableForDelivery,
    getStoreServiceModeStatuses,
    isMobileOrderingAvailable,
    isPOSAvailable,
  } = useStoreAvailabilityFns();

  return useCallback(
    (store: IRestaurant, forLogs: boolean = false): IStoreDiagnostics | undefined => {
      const availableDayParts = getAvailableDayParts(store);
      return {
        storeName: store.name || '',
        storeCountry: store?.physicalAddress?.country || '',
        storeStreetAddress: store?.physicalAddress?.address1 || '',
        storeId: store.number,
        storePosVendor: store.pos?.vendor,

        storeLocalTime: store.localTime,
        storeServiceModeHours: JSON.stringify(store.serviceModeHours),
        storeDayPartHours: JSON.stringify(store.dayPartHours),
        storeAvailableDayParts: availableDayParts?.map(dp => dp.key).join(','),

        storeHasMobileOrdering: Boolean(store.hasMobileOrdering),
        storeMobileOrderingStatus: store.mobileOrderingStatus,
        storeServiceModeStatuses: JSON.stringify(getStoreServiceModeStatuses(store)),
        isStoreAvailableForPickup: isStoreAvailableForPickup(store),
        isStoreAvailableForDelivery: isStoreAvailableForDelivery(store),
        isMobileOrderingAvailable: isMobileOrderingAvailable(store),
        isPOSAvailable: isPOSAvailable(store),
        isOneMenu: store.isOneMenu,
      };
    },
    [
      getStoreServiceModeStatuses,
      isMobileOrderingAvailable,
      isPOSAvailable,
      isStoreAvailableForDelivery,
      isStoreAvailableForPickup,
    ]
  );
};
